import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseRestService } from '../base-rest.service';
import { throwError as observableThrowError, Observable, of } from "rxjs";
import { CommonRequest } from '../../models/rest/common/commonRequest';
import { SmsLogReportResponse } from '../../models/rest/log/sms-log-report-response';
import { SmsLogStatusSummaryResponse } from '../../models/rest/log/sms-log-status-summary-response'
import { RefreshTokenHistoryResponse } from '../../models/rest/log/refresh-token-history-response';

import { catchError } from 'rxjs/operators';
import { CallerIdLogResponse } from '../../models/rest/log/caller-id-log-response.model';
import { GeneralLogSearchResponse } from '../../models/dto/general-log-search-response.model';
import { SessionStorageService } from "../session-storage.service";
import { LogSearchRequest } from '../../models/rest/common/log-search-request';

@Injectable({
  providedIn: 'root'
})
export class LogReportService extends BaseRestService {
  constructor(protected httpClient: HttpClient, protected sessionStorageService: SessionStorageService) {
    super(httpClient, sessionStorageService);
  }
  getSmsLogReport(search: CommonRequest): Observable<SmsLogReportResponse[]> {
    const url = `/logs/sms-log`;
    return this.httpPost<SmsLogReportResponse[]>(url, search).pipe(catchError(this.errorHandler));
  }

  getSmsLogStatusSummaryReport(search: CommonRequest): Observable<SmsLogStatusSummaryResponse[]> {
    const url = `/logs/sms-log-status-summary`;
    return this.httpPost<SmsLogStatusSummaryResponse[]>(url, search).pipe(catchError(this.errorHandler));
  }

  updateSmsState(data: CommonRequest) {
    const url = `/logs/update-sms-state`;
    return this.httpPost(url, data).pipe(catchError(this.errorHandler));
  }

  getRefreshTokenHistories(search: CommonRequest): Observable<RefreshTokenHistoryResponse[]> {
    const url = `/logs/refresh-token-history`;
    return this.httpPost<SmsLogReportResponse[]>(url, search).pipe(catchError(this.errorHandler));
  }


  getCallerıdLogReport(search: CommonRequest): Observable<CallerIdLogResponse[]> {
    const url = `/caller-id-logs/search`;
    return this.httpPost<CallerIdLogResponse[]>(url, search).pipe(catchError(this.errorHandler));
  }

  getGeneralLogs(search: LogSearchRequest): Observable<GeneralLogSearchResponse[]> {
    const url = `/logs/general-logs`;
    return this.httpPost<GeneralLogSearchResponse[]>(url, search).pipe(catchError(this.errorHandler));
  }

  errorHandler(error: HttpErrorResponse) {
    return observableThrowError(error);
  }

}
